import { Modal, Stack } from '@mantine/core';
import { useState } from 'react';
import Project from 'src/entities/project';

import useShareProjectModal from './useShareProjectModal';
import MembersSection from './MembersSection/MembersSection';
import ShareLinksSection from './ShareLinksSection/ShareLinksSection';

const SUBMODALS_STACK_ORDER = 2;

export type ShareProjectModalProps = {
	project: Project;
	onClose: () => void;
};

const ShareProjectModal = ( { project, onClose }: ShareProjectModalProps ) => {
	const {
		opened,
		totalCount,
		currentUserID,
		showManageReviewerRole,
		showViewOnlyLink,
		modalStyles
	} = useShareProjectModal( { project, onClose } );

	const [ viewOnlyWithDownloads, setViewOnlyWithDownloads ] = useState( true );

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			title={`Share ${project.name}`}
			className="ShareProjectModal"
			styles={modalStyles}
			overlayProps={{ sx: { backgroundColor: 'rgba(0, 0, 0, 0.25)' } }}
			size={466}
			closeOnEscape={false}
		>
			<Stack spacing={16}>
				<MembersSection
					project={project}
					currentUserID={currentUserID}
					totalCount={totalCount}
					addGroupModalStackOrder={SUBMODALS_STACK_ORDER}
				/>
				<ShareLinksSection
					project={project}
					showManageReviewerRole={showManageReviewerRole}
					showViewOnlyLink={showViewOnlyLink}
					viewOnlyWithDownloads={viewOnlyWithDownloads}
					onViewOnlyWithDownloadsChange={setViewOnlyWithDownloads}
				/>
			</Stack>
		</Modal>
	);
};

export default ShareProjectModal;
